export default "__VITE_ASSET__Bbt70hJK__"